var map = {
	"./1-VISA-logo.png": 3728,
	"./2 - Mastercard-logo.svg.png": 7464,
	"./3 - American-Express-logo.png": 5834,
	"./4 - paynow.png": 334,
	"./z-QR.png": 5713,
	"Common/Components/AppFooter/Assets/Icons/Png/1-VISA-logo.png": 3728,
	"Common/Components/AppFooter/Assets/Icons/Png/2 - Mastercard-logo.svg.png": 7464,
	"Common/Components/AppFooter/Assets/Icons/Png/3 - American-Express-logo.png": 5834,
	"Common/Components/AppFooter/Assets/Icons/Png/4 - paynow.png": 334,
	"Common/Components/AppFooter/Assets/Icons/Png/z-QR.png": 5713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 479;